// Constants:
export const NODE_DRAG_DISTANCE_THRESHOLD = 1


// Exports:
export default (clickOrigin, e) => Math.sqrt(Math.pow(clickOrigin.y - e.clientY, 2) + Math.pow(clickOrigin.x - e.clientX, 2)) > NODE_DRAG_DISTANCE_THRESHOLD
